import styled from 'styled-components';
import { defaultColors } from '@components/themes';
import { Box } from '@components/Box';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const RunTheShowWrapper = styled(Box)`
  background-color: ${themeColor('blue6')};
`;

export const Toggle = styled.div`
  width: 300px;
  border-radius: 119px;
  background-color: ${themeColor('blue5')};
  padding: 18px;
  margin: auto;
  margin-top: 197px;
  margin-bottom: 86px;
  align-self: center;
`;

export const Circle = styled.div`
  height: 150px;
  width: 150px;
  border-radius: 100%;
  background-color: ${defaultColors.mono7};
`;
